import React from "react";

import { Text } from "@performyard/py-components";

const ClampedTableText = ({ children, lines = 1 }: { children: React.ReactNode; lines?: number }) => (
	<div className={`py-line-clamp-${lines}`}>
		<Text size="paragraph-3" weight="regular">
			{children}
		</Text>
	</div>
);

export default ClampedTableText;
